// :cow: Cosmose CONFIDENTIAL :iso:
import { ExecutionTypes } from '@med/app/home/campaign/modules/execution//model/execution.model';
import { AssetPackage } from '@med/app/home/campaign/modules/execution/model/asset.model';

export interface ExecutionState {
  visited: ExecutionTypes[];
  isErrorVisible: boolean;
  assetPackages: AssetPackage[];
}

export const initialState: ExecutionState = {
  visited: [],
  isErrorVisible: false,
  assetPackages: [],
};
